/**
 * Shared enums for Account/Contract Sequence Types
 * Used across API, API2, and Dashboard
 */

export enum ContractSequenceType {
	SERVICE_PROVIDER = 'serviceProvider',
	TOUR_OPERATOR = 'tourOperator'
}

export enum InvitationRole {
	USER = 'User',
	ADMIN = 'Admin',
}

export enum UserType {
	SERVICE_PROVIDER = 'serviceprovider',
	OPERATOR = 'operator',
	ADMIN = 'admin',
	TRADE_HUB = 'tradehub'
}